// extracted by mini-css-extract-plugin
export var darkMode = "_g-0";